import React from "react";
import Teacher1 from "../../assets/teacher/Zhao.jpg";
import Teacher2 from "../../assets/teacher/Catherine.jpg";
import Teacher3 from "../../assets/teacher/Lee.jpg";
import Teacher4 from "../../assets/teacher/Su.jpg";
import Teacher5 from "../../assets/teacher/Lim.jpeg";
import Teacher6 from "../../assets/teacher/Lai.jpg";
import Teacher7 from "../../assets/teacher/Suarnah.jpeg";
import Teacher8 from "../../assets/teacher/Zhen.jpg";
import BC from "../../assets/BC.jpeg";
import Math from "../../assets/Math.jpeg";
import Bio from "../../assets/Bio.jpeg";
import Chem from "../../assets/Chem.jpeg";
import Acc from "../../assets/Acc.jpeg";

export const WA_NUMBER = "60179889559";
export const WA_COMMUNITY_LINK =
  "https://chat.whatsapp.com/LLgZHDiJbzFG1b4hcY06f7";
export const FONT = "'Noto Sans SC', 'Inter', sans-serif";

export const SCHEDULE = [
  {
    date: "21 Sep 2026",
    day: "星期一",
    subject: "高中华文",
    teacher: "趙翠玲老师",
    color: "#E53935",
    rest: false,
  },
  {
    date: "22 Sep 2026",
    day: "星期二",
    subject: "高中数学",
    teacher: "Catherine May Hui 老师",
    color: "#1565C0",
    rest: false,
  },
  {
    date: "23 Sep 2026",
    day: "星期三",
    subject: "休息日",
    teacher: "",
    color: "#9E9E9E",
    rest: true,
  },
  {
    date: "24 Sep 2026",
    day: "星期四",
    subject: "高中生物",
    teacher: "李恩慧老师",
    color: "#2E7D32",
    rest: false,
  },
  {
    date: "25 Sep 2026",
    day: "星期五",
    subject: "高中化学",
    teacher: "苏凌蔚老师",
    color: "#6A1B9A",
    rest: false,
  },
  {
    date: "28 Sep 2026",
    day: "星期一",
    subject: "高中物理",
    teacher: "林家益老师",
    color: "#00838F",
    rest: false,
  },
  {
    date: "29 Sep 2026",
    day: "星期二",
    subject: "高中会计学",
    teacher: "赖伟伦老师",
    color: "#E65100",
    rest: false,
  },
  {
    date: "30 Sep 2026",
    day: "星期三",
    subject: "高中英文",
    teacher: "Ms. Suarnah",
    color: "#AD1457",
    rest: false,
  },
  {
    date: "1 Oct 2026",
    day: "星期四",
    subject: "高级数学",
    teacher: "郑老师",
    color: "#283593",
    rest: false,
  },
];

export const TEACHERS = [
  {
    id: "uec_teacher_cn",
    name: "趙翠玲老师",
    subject: "高中华文",
    avatar: Teacher1,
    color: "#E53935",
    credentials: [
      "现任沙巴崇正中学华文老师",
      "毕业于中国华中师范大学课程与教学论教育硕士",
      "超过 25 年华文教学经验",
      "多次担任董总公开课授课老师",
    ],
  },
  {
    id: "uec_teacher_math",
    name: "Catherine May Hui 老师",
    subject: "高中数学",
    avatar: Teacher2,
    color: "#1565C0",
    credentials: [
      "毕业于会计与金融学士",
      "超过 6 年数学教学经验",
      "曾荣获不同数学竞赛奖项",
    ],
  },
  {
    id: "uec_teacher_bio",
    name: "李恩慧老师",
    subject: "高中生物",
    avatar: Teacher3,
    color: "#2E7D32",
    credentials: [
      "毕业于台湾阳明交通大学理学学士、上海交通大学药学院医学硕士",
      "超过 7 年生物教学经验",
      "曾指导学生在国际竞赛中夺得金牌",
    ],
  },
  {
    id: "uec_teacher_chem",
    name: "苏凌蔚老师",
    subject: "高中化学",
    avatar: Teacher4,
    color: "#6A1B9A",
    credentials: [
      "毕业于马来亚大学纯化学系、台湾彰化师范大学数理创意教学硕士",
      "超过 15 年教学经验",
      "连续 3 年受邀到董总全马独中公开课分享",
      "董总高中化学课本编审",
    ],
  },
  {
    id: "uec_teacher_phy",
    name: "林家益老师",
    subject: "高中物理",
    avatar: Teacher5,
    color: "#00838F",
    credentials: [
      "曾就读于台湾国立清华大学物理系",
      "13 年物理与科学补习教学经验",
      "担任巴生滨华中学兼职高中物理老师五年",
      "擅长生活化教学化繁为简",
    ],
  },
  {
    id: "uec_teacher_acc",
    name: "赖伟伦老师",
    subject: "高中会计学",
    avatar: Teacher6,
    color: "#E65100",
    credentials: [
      "吉隆坡地区独立中学任职会计学教师",
      "毕业于拉曼理工大学商业学士、开放大学马来西亚教育学士",
      "超过 10 年会计学教学经验",
      "2025 年带领学生在双威大学商业创新挑战赛入围十强",
    ],
  },
  {
    id: "uec_teacher_eng",
    name: "Ms. Suarnah",
    subject: "高中英文",
    avatar: Teacher7,
    color: "#AD1457",
    credentials: [
      "现任巴生兴华中学英文科教师",
      "毕业于拉曼大学（UTAR）英语系、管理与科学大学教育硕士",
      "持有国际英语教师资格认证（TESOL）",
      "超过 11 年英文教学经验",
    ],
  },
  {
    id: "uec_teacher_add_math",
    name: "郑老师",
    subject: "高级数学",
    avatar: Teacher8,
    color: "#283593",
    credentials: [
      "澳洲塔斯马尼亚大学银行与金融系毕业",
      "从事教育行业超过 27 年",
      "专教初高中独中数学、SPM 及 STPM 数学",
    ],
  },
];

export const BENEFITS = [
  {
    icon: "📌",
    title: "名师整理考试重点",
    desc: "快速掌握各科重点，不必自己摸索。",
  },
  {
    icon: "📝",
    title: "免费 A1 考试笔记",
    desc: "老师整理重点内容，方便考前快速复习。",
  },
  {
    icon: "🎯",
    title: "考试取分技巧",
    desc: "了解高分答题方式，提高作答效率。",
  },
  {
    icon: "🎙️",
    title: "Live Revision & Q&A",
    desc: "现场与老师互动，把不会的问题问清楚。",
  },
  {
    icon: "🎓",
    title: "升学与奖学金资讯",
    desc: "提前了解统考后的大学升学方向与奖学金资讯。",
  },
];

export const PAIN_POINTS = [
  { pain: "找不到重点？", solution: "统考前最后冲刺，快速抓住必考内容" },
  {
    pain: "时间不够用？",
    solution: "考试避雷与作答技巧，避开常见错误，减少扣分",
  },
  {
    pain: "答案不能拿满分？",
    solution: "考试攻略笔记，教你「怎么写更容易拿分」",
  },
];

export const TESTIMONIALS = [
  {
    name: "刘欣宜",
    role: "UEC 考生 · 高三生",
    stars: 5,
    text: "参加了这个攻略班之后，我终于知道每一科的必考重点在哪里。老师讲得非常清楚，而且免费笔记真的救了我！统考成绩进步了很多，非常推荐！",
  },
  {
    name: "陈俊豪",
    role: "UEC 考生 · 高三生",
    stars: 5,
    text: "化学老师用很生活化的方式解释有机化学，听完之后感觉豁然开朗。原来答题有这么多技巧！而且全程免费，真的赚到了。",
  },
  {
    name: "林美华（家长）",
    role: "高三生家长",
    stars: 5,
    text: "孩子参加了统考攻略班之后，整个人变得更有信心。老师们都很专业，而且课程免费，对我们家长来说真的减轻了很多负担。强烈推荐！",
  },
  {
    name: "张文杰",
    role: "UEC 考生 · 高三生",
    stars: 5,
    text: "数学和物理一直是我的弱点，参加攻略班之后，我学会了如何系统地整理笔记和答题。Live Q&A 环节让我可以直接问老师问题，非常有帮助！",
  },
];

export const FAQS = [
  { q: "一定要全部科目都报名吗？", a: "不用，可以自由选择想参加的科目。" },
  {
    q: "这个考试攻略班是免费的吗？",
    a: "是的，完全免费参与（100% 不收费），报名后即可直接上课。赶快报名参加吧！",
  },
  {
    q: "没有基础可以参加吗？",
    a: "可以，该攻略班适合所有统考生，无论基础如何都欢迎参加。",
  },
  {
    q: "会提供课程回放吗？",
    a: "所有课程都会提供回放，活动结束后会由 SCS 工作人员陆续上传。",
  },
  {
    q: "高一、高二生可以参加吗？",
    a: "当然可以！提前了解统考考试方向和技巧，对高一高二生来说是非常好的早期准备。",
  },
  {
    q: "上课链接和笔记怎么领取？",
    a: "报名后，SCS 辅导员会通过 WhatsApp 联系您，并发送 Zoom 上课链接、考试笔记及最新通知。",
  },
];

export const SUBJECT_ICONS: Record<string, React.ReactElement> = {
  高中华文: /* @__PURE__ */ React.createElement(
    "svg",
    { viewBox: "0 0 40 40", fill: "none", className: "w-full h-full" },
    /* @__PURE__ */ React.createElement("rect", {
      x: "6",
      y: "4",
      width: "22",
      height: "28",
      rx: "3",
      fill: "white",
      fillOpacity: "0.2",
    }),
    /* @__PURE__ */ React.createElement("rect", {
      x: "8",
      y: "6",
      width: "18",
      height: "24",
      rx: "2",
      stroke: "white",
      strokeWidth: "1.5",
      fill: "none",
    }),
    /* @__PURE__ */ React.createElement("line", {
      x1: "12",
      y1: "12",
      x2: "22",
      y2: "12",
      stroke: "white",
      strokeWidth: "1.5",
      strokeLinecap: "round",
    }),
    /* @__PURE__ */ React.createElement("line", {
      x1: "12",
      y1: "16",
      x2: "22",
      y2: "16",
      stroke: "white",
      strokeWidth: "1.5",
      strokeLinecap: "round",
    }),
    /* @__PURE__ */ React.createElement("line", {
      x1: "12",
      y1: "20",
      x2: "18",
      y2: "20",
      stroke: "white",
      strokeWidth: "1.5",
      strokeLinecap: "round",
    }),
    /* @__PURE__ */ React.createElement("circle", {
      cx: "28",
      cy: "28",
      r: "7",
      fill: "white",
      fillOpacity: "0.15",
    }),
    /* @__PURE__ */ React.createElement(
      "text",
      {
        x: "28",
        y: "32",
        textAnchor: "middle",
        fill: "white",
        fontSize: "9",
        fontWeight: "bold",
      },
      "\u6587",
    ),
  ),
  高中数学: /* @__PURE__ */ React.createElement(
    "svg",
    { viewBox: "0 0 40 40", fill: "none", className: "w-full h-full" },
    /* @__PURE__ */ React.createElement("path", {
      d: "M8 32 Q14 8 20 20 Q26 32 32 8",
      stroke: "white",
      strokeWidth: "2",
      strokeLinecap: "round",
      fill: "none",
    }),
    /* @__PURE__ */ React.createElement("line", {
      x1: "6",
      y1: "20",
      x2: "34",
      y2: "20",
      stroke: "white",
      strokeWidth: "1",
      strokeOpacity: "0.4",
    }),
    /* @__PURE__ */ React.createElement("line", {
      x1: "20",
      y1: "6",
      x2: "20",
      y2: "34",
      stroke: "white",
      strokeWidth: "1",
      strokeOpacity: "0.4",
    }),
    /* @__PURE__ */ React.createElement("circle", {
      cx: "20",
      cy: "20",
      r: "2.5",
      fill: "white",
    }),
  ),
  高中生物: /* @__PURE__ */ React.createElement(
    "svg",
    { viewBox: "0 0 40 40", fill: "none", className: "w-full h-full" },
    /* @__PURE__ */ React.createElement("path", {
      d: "M16 6 C22 10 22 16 16 20 C10 24 10 30 16 34",
      stroke: "white",
      strokeWidth: "2",
      strokeLinecap: "round",
      fill: "none",
    }),
    /* @__PURE__ */ React.createElement("path", {
      d: "M24 6 C18 10 18 16 24 20 C30 24 30 30 24 34",
      stroke: "white",
      strokeWidth: "2",
      strokeLinecap: "round",
      fill: "none",
    }),
    /* @__PURE__ */ React.createElement("line", {
      x1: "16",
      y1: "12",
      x2: "24",
      y2: "12",
      stroke: "white",
      strokeWidth: "1.5",
      strokeLinecap: "round",
    }),
    /* @__PURE__ */ React.createElement("line", {
      x1: "13",
      y1: "18",
      x2: "27",
      y2: "18",
      stroke: "white",
      strokeWidth: "1.5",
      strokeLinecap: "round",
    }),
    /* @__PURE__ */ React.createElement("line", {
      x1: "16",
      y1: "24",
      x2: "24",
      y2: "24",
      stroke: "white",
      strokeWidth: "1.5",
      strokeLinecap: "round",
    }),
    /* @__PURE__ */ React.createElement("line", {
      x1: "13",
      y1: "30",
      x2: "27",
      y2: "30",
      stroke: "white",
      strokeWidth: "1.5",
      strokeLinecap: "round",
    }),
  ),
  高中化学: /* @__PURE__ */ React.createElement(
    "svg",
    { viewBox: "0 0 40 40", fill: "none", className: "w-full h-full" },
    /* @__PURE__ */ React.createElement("path", {
      d: "M15 6 L15 18 L8 32 Q7 34 9 34 L31 34 Q33 34 32 32 L25 18 L25 6 Z",
      stroke: "white",
      strokeWidth: "1.5",
      fill: "white",
      fillOpacity: "0.15",
    }),
    /* @__PURE__ */ React.createElement("line", {
      x1: "13",
      y1: "10",
      x2: "27",
      y2: "10",
      stroke: "white",
      strokeWidth: "1.5",
      strokeLinecap: "round",
    }),
    /* @__PURE__ */ React.createElement("circle", {
      cx: "14",
      cy: "27",
      r: "2",
      fill: "white",
      fillOpacity: "0.6",
    }),
    /* @__PURE__ */ React.createElement("circle", {
      cx: "20",
      cy: "24",
      r: "1.5",
      fill: "white",
      fillOpacity: "0.4",
    }),
    /* @__PURE__ */ React.createElement("circle", {
      cx: "26",
      cy: "28",
      r: "2.5",
      fill: "white",
      fillOpacity: "0.5",
    }),
  ),
  高中物理: /* @__PURE__ */ React.createElement(
    "svg",
    { viewBox: "0 0 40 40", fill: "none", className: "w-full h-full" },
    /* @__PURE__ */ React.createElement("circle", {
      cx: "20",
      cy: "20",
      r: "10",
      stroke: "white",
      strokeWidth: "1.5",
      fill: "none",
    }),
    /* @__PURE__ */ React.createElement("ellipse", {
      cx: "20",
      cy: "20",
      rx: "10",
      ry: "4",
      stroke: "white",
      strokeWidth: "1.5",
      strokeOpacity: "0.5",
      fill: "none",
    }),
    /* @__PURE__ */ React.createElement("ellipse", {
      cx: "20",
      cy: "20",
      rx: "4",
      ry: "10",
      stroke: "white",
      strokeWidth: "1.5",
      strokeOpacity: "0.5",
      fill: "none",
    }),
    /* @__PURE__ */ React.createElement("circle", {
      cx: "20",
      cy: "20",
      r: "2.5",
      fill: "white",
    }),
  ),
  高中会计学: /* @__PURE__ */ React.createElement(
    "svg",
    { viewBox: "0 0 40 40", fill: "none", className: "w-full h-full" },
    /* @__PURE__ */ React.createElement("rect", {
      x: "7",
      y: "26",
      width: "6",
      height: "10",
      rx: "1.5",
      fill: "white",
      fillOpacity: "0.5",
    }),
    /* @__PURE__ */ React.createElement("rect", {
      x: "17",
      y: "18",
      width: "6",
      height: "18",
      rx: "1.5",
      fill: "white",
      fillOpacity: "0.7",
    }),
    /* @__PURE__ */ React.createElement("rect", {
      x: "27",
      y: "10",
      width: "6",
      height: "26",
      rx: "1.5",
      fill: "white",
    }),
    /* @__PURE__ */ React.createElement("polyline", {
      points: "10,22 20,14 30,8",
      stroke: "white",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round",
    }),
    /* @__PURE__ */ React.createElement("circle", {
      cx: "30",
      cy: "8",
      r: "2",
      fill: "white",
    }),
  ),
  高中英文: /* @__PURE__ */ React.createElement(
    "svg",
    { viewBox: "0 0 40 40", fill: "none", className: "w-full h-full" },
    /* @__PURE__ */ React.createElement("rect", {
      x: "7",
      y: "8",
      width: "26",
      height: "20",
      rx: "3",
      stroke: "white",
      strokeWidth: "1.5",
      fill: "white",
      fillOpacity: "0.1",
    }),
    /* @__PURE__ */ React.createElement("line", {
      x1: "12",
      y1: "14",
      x2: "28",
      y2: "14",
      stroke: "white",
      strokeWidth: "1.5",
      strokeLinecap: "round",
    }),
    /* @__PURE__ */ React.createElement("line", {
      x1: "12",
      y1: "19",
      x2: "28",
      y2: "19",
      stroke: "white",
      strokeWidth: "1.5",
      strokeLinecap: "round",
    }),
    /* @__PURE__ */ React.createElement("line", {
      x1: "12",
      y1: "24",
      x2: "21",
      y2: "24",
      stroke: "white",
      strokeWidth: "1.5",
      strokeLinecap: "round",
    }),
    /* @__PURE__ */ React.createElement("path", {
      d: "M23 30 L20 34 L34 34 L31 30 Z",
      fill: "white",
      fillOpacity: "0.6",
    }),
  ),
  高级数学: /* @__PURE__ */ React.createElement(
    "svg",
    { viewBox: "0 0 40 40", fill: "none", className: "w-full h-full" },
    /* @__PURE__ */ React.createElement("line", {
      x1: "6",
      y1: "34",
      x2: "34",
      y2: "34",
      stroke: "white",
      strokeWidth: "1.5",
      strokeLinecap: "round",
    }),
    /* @__PURE__ */ React.createElement("line", {
      x1: "6",
      y1: "6",
      x2: "6",
      y2: "34",
      stroke: "white",
      strokeWidth: "1.5",
      strokeLinecap: "round",
    }),
    /* @__PURE__ */ React.createElement("path", {
      d: "M6 28 C10 28 12 10 16 10 C20 10 20 22 24 18 C28 14 30 20 34 16",
      stroke: "white",
      strokeWidth: "2",
      strokeLinecap: "round",
      fill: "none",
    }),
    /* @__PURE__ */ React.createElement(
      "text",
      {
        x: "28",
        y: "12",
        fill: "white",
        fontSize: "7",
        fontWeight: "bold",
        fillOpacity: "0.8",
      },
      "\u222B",
    ),
  ),
  休息日: /* @__PURE__ */ React.createElement(
    "svg",
    { viewBox: "0 0 40 40", fill: "none", className: "w-full h-full" },
    /* @__PURE__ */ React.createElement("circle", {
      cx: "20",
      cy: "18",
      r: "8",
      stroke: "white",
      strokeWidth: "1.5",
      strokeOpacity: "0.5",
      fill: "none",
    }),
    /* @__PURE__ */ React.createElement("path", {
      d: "M16 14 Q20 10 24 14",
      stroke: "white",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeOpacity: "0.5",
      fill: "none",
    }),
    /* @__PURE__ */ React.createElement("path", {
      d: "M15 26 Q20 30 25 26",
      stroke: "white",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeOpacity: "0.5",
      fill: "none",
    }),
    /* @__PURE__ */ React.createElement(
      "text",
      {
        x: "20",
        y: "22",
        textAnchor: "middle",
        fill: "white",
        fontSize: "10",
        fillOpacity: "0.5",
      },
      "z",
    ),
  ),
};

export const CLASS_SCREENSHOT = [BC, Math, Bio, Chem, Acc];
// ----- Form Data --------------------------------------------------
export const IDENTITY = [
  {
    label: "2026 高三生",
    value: "2026 UEC Senior 3",
  },
  {
    label: "高二生",
    value: "UEC Senior 2",
  },
  {
    label: "高一生",
    value: "UEC Senior 1",
  },
  {
    label: "老师",
    value: "Teacher",
  },
  {
    label: "家长",
    value: "Parent",
  },
];

export const DISCOVERY_SOURCE = [
  {
    label: "Facebook",
    value: "Facebook",
  },
  {
    label: "Instagram",
    value: "Instagram",
  },
  {
    label: "朋友介绍",
    value: "Friend Referral",
  },
  {
    label: "SCS 工作人员",
    value: "SCS Staff",
  },
  {
    label: "学校老师",
    value: "School Teacher",
  },
];

export const COURSES = [
  {
    label: "高中华文",
    value: "Chinese",
  },
  {
    label: "高中数学",
    value: "Mathematics",
  },
  {
    label: "高中生物",
    value: "Biology",
  },
  {
    label: "高中化学",
    value: "Chemistry",
  },
  {
    label: "高中物理",
    value: "Physics",
  },
  {
    label: "高中会计学",
    value: "Bookkeeping",
  },
  {
    label: "高中英文",
    value: "English",
  },
  {
    label: "高级数学",
    value: "Additional Mathematics",
  },
];
